export default "__VITE_ASSET__TN3oyqiM__"